// 首页查询模块
import Axios from './config'

//头部列表接口
const headerlist = (params) => {
  return Axios({
    method: 'get',
    url: `/web/pubitem/itemList/commonRequest`,
    params: params
  })
}
//指标查询排行榜接口
const searchtop = (params) => {
  return Axios({
    method: 'get',
    url: `/web/search/list`,
    params: params
  })
}
//图表详情接口
const chartsdata = (params) => {
  return Axios({
    method: 'get',
    url: `/web/pubitem/dataIndicator/indicatorList`,
    params: params
  })
}

//搜索详情接口
const searchdata = (params) => {
  return Axios({
    method: 'get',
    url: `/web/pubitem/itemResource/searchItem`,
    params: params
  })
}


export{
  headerlist,chartsdata,searchdata,searchtop
}


// WEBPACK FOOTER //
// ./src/api/index.js